if (!customElements.get('palmera-bundle')) customElements.define('palmera-bundle', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.galleryObservers?.forEach(observer => observer.disconnect());
    this.galleryObservers = [];
    this.galleryCleanups?.forEach(cleanup => cleanup());
    this.galleryCleanups = [];
    this.querySelectorAll('.pb218-gallery').forEach(gallery => {
      const track = gallery.querySelector('.pb218-track');
      const slides = [...track.children];
      let index = 0;
      let heightFrame = 0;
      let lastSyncedIndex = -1;
      let slideHeights = [];
      const fitHeight = () => {
        if (!track.clientWidth || !slideHeights.length) return;
        const position = Math.max(0, Math.min(slides.length - 1, track.scrollLeft / track.clientWidth));
        const left = Math.floor(position);
        const right = Math.min(slides.length - 1, left + 1);
        const fraction = position - left;
        const height = Math.ceil(matchMedia('(min-width: 768px)').matches ? Math.max(...slideHeights) : slideHeights[left] * (1 - fraction) + slideHeights[right] * fraction);
        if (height > 0 && track.style.height !== height + 'px') track.style.height = height + 'px';
      };
      const queueHeight = () => {
        if (!heightFrame) heightFrame = requestAnimationFrame(() => { heightFrame = 0; fitHeight(); });
      };
      this.galleryCleanups.push(() => { cancelAnimationFrame(heightFrame); });
      const sync = () => {
        index = Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft / Math.max(1,track.clientWidth))));

        if (index === lastSyncedIndex) return;
        lastSyncedIndex = index;
        gallery.querySelector('[data-gallery-count]').textContent = `${index+1} / ${slides.length}`;
        gallery.querySelector('[data-gallery-prev]').disabled = index === 0;
        gallery.querySelector('[data-gallery-next]').disabled = index === slides.length-1;
        gallery.querySelectorAll('.pb218-thumbs [data-slide-to], .pb219-dots [data-slide-to]').forEach(b => b.setAttribute('aria-current',String(Number(b.dataset.slideTo) === index)));
      };
      const go = n => track.scrollTo({left:Math.max(0,Math.min(slides.length-1,n))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});

      // A deliberate horizontal touch advances at most one slide; vertical page scrolling stays native.
      let gesture = null;
      let suppressClickUntil = 0;
      track.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) {
          gesture = null;
          track.removeAttribute('data-dragging');
          return;
        }
        const touch = event.touches[0];
        gesture = { x: touch.clientX, y: touch.clientY, start: index, dx: 0, horizontal: false, vertical: false };
      }, { passive: true, signal: this.abort.signal });
      track.addEventListener('touchmove', event => {
        if (!gesture || event.touches.length !== 1 || gesture.vertical) return;
        const dx = event.touches[0].clientX - gesture.x;
        const dy = event.touches[0].clientY - gesture.y;
        if (!gesture.horizontal) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          if (Math.abs(dy) >= Math.abs(dx)) { gesture.vertical = true; return; }
          gesture.horizontal = true;
          track.setAttribute('data-dragging', '');
        }
        if (event.cancelable) event.preventDefault();
        gesture.dx = dx;
        const width = track.clientWidth;
        const low = Math.max(0, gesture.start - 1) * width;
        const high = Math.min(slides.length - 1, gesture.start + 1) * width;
        track.scrollLeft = Math.max(low, Math.min(high, gesture.start * width - dx));
        queueHeight();
      }, { passive: false, signal: this.abort.signal });
      const finishGesture = cancelled => {
        const previous = gesture;
        gesture = null;
        track.removeAttribute('data-dragging');
        if (!previous?.horizontal) return;
        const threshold = Math.max(24, track.clientWidth * .08);
        const step = !cancelled && Math.abs(previous.dx) >= threshold ? (previous.dx < 0 ? 1 : -1) : 0;
        suppressClickUntil = Date.now() + 350;
        go(previous.start + step);
      };
      track.addEventListener('touchend', () => finishGesture(false), { passive: true, signal: this.abort.signal });
      track.addEventListener('touchcancel', () => finishGesture(true), { passive: true, signal: this.abort.signal });
      track.addEventListener('click', event => {
        if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
      }, { capture: true, signal: this.abort.signal });

      gallery.querySelectorAll('[data-slide-to]').forEach(b => b.addEventListener('click',()=>go(Number(b.dataset.slideTo)),{signal:this.abort.signal}));
      gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>go(index-1),{signal:this.abort.signal});
      gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>go(index+1),{signal:this.abort.signal});
      track.addEventListener('scroll', () => { sync(); queueHeight(); }, {passive:true,signal:this.abort.signal});
      track.addEventListener('scrollend', () => { sync(); queueHeight(); }, {passive:true,signal:this.abort.signal});
      track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}},{signal:this.abort.signal});
      const measureSlides = () => {
        slideHeights = slides.map(slide => slide.getBoundingClientRect().height);
        sync(); fitHeight();
      };
      const galleryObserver = new ResizeObserver(measureSlides);
      slides.forEach(slide => galleryObserver.observe(slide));
      this.galleryObservers.push(galleryObserver);
      measureSlides();
    });
    const variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
    const selectors = [...this.querySelectorAll('[data-option]')];
    const form = this.querySelector('form.main-product-form');
    const button = form.querySelector('[type=submit]');
    const update = () => {
      const v = variants.find(v => v.options.every((o, i) => o === selectors.find(s => Number(s.dataset.option) === i && s.checked)?.value));
      const panels = [...this.querySelectorAll('[data-panel]')];
      panels.forEach(p => p.hidden = !v || p.dataset.panel !== String(v.id));
      this.querySelectorAll('[data-bundle-facts]').forEach(p => p.hidden = !v || p.dataset.bundleFacts !== String(v.id));
      const meta = panels.find(p => !p.hidden)?.querySelector('.pb214-meta');
      const sticky = this.querySelector('sticky-atc-bar-minimalist');
      if (!v || !meta) {
        button.disabled = true;
        sticky?.updateButton?.(true, 'Ikke tilgjengelig');
        return;
      }
      form.querySelector('[name=id]').value = v.id;
      for (const key of ['price', 'saving', 'separate']) this.querySelector('.pb214-pricebox [data-' + key + ']').textContent = meta.dataset[key];
      this.querySelector('[data-selection]').textContent = meta.dataset.summary;
      const available = meta.dataset.available === 'true';
      button.disabled = !available;
      const stockStatus = this.querySelector('[data-bundle-stock-status]');
      if (stockStatus) {
        stockStatus.hidden = !available;
        const quantity = Number(meta.dataset.quantity || 0);
        const text = 'På lager - sendes innen 24 timer';
        stockStatus.querySelector('[data-bundle-stock-text]').textContent = text;
      }
      button.querySelector('.btn__text').textContent = available ? 'Legg i handlekurv' : 'Kombinasjonen er utsolgt';
      const stockMessage = this.querySelector('[data-stock]');
      stockMessage.hidden = available;
      const choiceHelp = this.classList.contains('pb243-plants-only') ? ' Vent til varen er tilbake.' : ' Velg en annen farge, eller vent til varen er tilbake.';
      stockMessage.textContent = available ? '' : (meta.dataset.missing ? meta.dataset.missing + ' er ikke på lager i nødvendig antall.' + choiceHelp : 'Denne pakken er ikke tilgjengelig akkurat nå.' + choiceHelp);
      const goal = document.querySelector('free-shipping-goal[data-minimum-amount]');
      const threshold = Number(goal?.dataset.minimumAmount || 0) * Number(window.Shopify?.currency?.rate || 1) * 100;
      const shipping = threshold > 0 && v.price >= threshold ? 'Gratis frakt' : 'Rask levering';
      const shippingLabel = this.querySelector('.palmera-purchase-pill--shipping .inline-richtext');
      if (shippingLabel) shippingLabel.textContent = shipping;
      if(sticky) {
        sticky.currentVariantPrice = v.price;
        sticky.updatePrice?.(v);
        sticky.updateButton?.(!available, 'Kombinasjonen er utsolgt');
        const pill = sticky.querySelector('.sticky-atc-bar__shipping-badge .inline-richtext');
        if(pill) pill.textContent = shipping;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    };
    this.addEventListener('palmera:sticky-layout',update,{signal:this.abort.signal});
    selectors.forEach(s => s.addEventListener('change', update, {signal:this.abort.signal}));
    this.infoObserver = new ResizeObserver(entries => {
      const height = entries[0].target.getBoundingClientRect().height;
      this.style.setProperty('--pb216-info-height', height + 'px');
    });
    this.infoObserver.observe(this.querySelector('.pb214-info'));
    form.addEventListener('submit', async event => {
      if (this.checkedSubmission) {this.checkedSubmission = false; return;}
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.checking) return;
      this.checking = true;
      const id = form.querySelector('[name=id]').value;
      const sticky = this.querySelector('sticky-atc-bar-minimalist');
      try {
        const url = new URL(location.href);
        url.searchParams.set('section_id', this.querySelector('product-info').dataset.section);
        url.searchParams.set('variant', id);
        const response = await fetch(url, {cache:'no-store', signal:this.abort.signal});
        if (!response.ok) throw new Error('availability');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector('[data-panel="' + id + '"] .pb214-meta');
        if (!fresh) throw new Error('availability');
        const local = this.querySelector('[data-panel="' + id + '"] .pb214-meta');
        local.dataset.available = fresh.dataset.available;
        local.dataset.missing = fresh.dataset.missing;
        local.dataset.quantity = fresh.dataset.quantity;
        if (id !== form.querySelector('[name=id]').value) {sticky?.resetButtonLoading?.(); return;}
        update();
        if (fresh.dataset.available !== 'true') {
          sticky?.resetButtonLoading?.();
          this.querySelector('[data-stock]').scrollIntoView({behavior:'smooth',block:'center'});
          return;
        }
        this.checkedSubmission = true;
        form.requestSubmit(button);
      } catch (error) {
        sticky?.resetButtonLoading?.();
        const message = this.querySelector('[data-stock]');
        message.hidden = false;
        message.textContent = 'Vi fikk ikke kontrollert lagerstatus. Prøv igjen om litt.';
        message.scrollIntoView({behavior:'smooth',block:'center'});
      } finally { this.checking = false; }
    }, {capture:true,signal:this.abort.signal});
    update();
    customElements.whenDefined('sticky-atc-bar-minimalist').then(() => {if(this.isConnected) update();});
  }
  disconnectedCallback() { this.abort?.abort(); this.infoObserver?.disconnect(); this.galleryCleanups?.forEach(cleanup => cleanup()); this.galleryObservers?.forEach(observer => observer.disconnect()); }
});